import DecisionChart from "./EUDecisionChart";
import Question from "./EUQuestion";
import QuestionChat from "./EUQuestionChat";

const EUChangeManagementContent = () => {
  return (
    <div className="flex h-full flex-col lg:flex-row">
      <div className="rounded-box flex flex-1 flex-col gap-4 bg-white p-3 lg:flex-[2] lg:gap-8">
        <div className="card min-h-[200px] bg-gray-200 p-4 shadow-xl lg:min-h-[180px] lg:p-6">
          <Question />
        </div>
        <div className="max-h-[calc(100vh-250px)] min-h-[calc(100vh-450px)] flex-1 overflow-hidden lg:max-h-[calc(100vh-300px)] lg:min-h-[calc(100vh-500px)]">
          <QuestionChat />
        </div>
      </div>
      <div className="ml-4 min-h-[400px] lg:min-h-full lg:flex-1">
        <DecisionChart />
      </div>
    </div>
  );
};
export default EUChangeManagementContent;
